@if (show) {
  <div class="custom-form-popup analyte-form-popup edit-comment-popup">
    <div class="modal-dialog" (clickOutside)="hideForm()">
      <div class="modal-content">
        <div class="modal-body">
          <h4 class="modal-title card-title" id="exampleModalLabel5">{{'Edit' | translate}} {{'Comment' | translate}}</h4>
          <form [formGroup]="commentForm">
            <div class="row align-items-center mb-8">
              <div class="col-md-12">
                <div class="form-group">
                  <label>{{'Comment' | translate}}</label>
                  <input class="form-control" formControlName="text">
                  @if (commentFormSubmitted && cf.text?.errors) {
                    <div class="form-error">
                      @if (cf.text.errors?.required) {
                        <span>{{'Please enter comment' | translate}}.</span>
                      }
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-md-6">
                <div class="buttons-div">
                  <button class="btn main-btn submit" (click)="submitForm()"
                  type="button">{{'Update' | translate}}</button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
}